export function addTabIdToLayout(outerLayout, tabId) {
  return outerLayout.map((item) => {
    return {
      ...item,
      tab_id: tabId
    };
  });
}

export function addTabIdToLayoutIfMissing(outerLayout, tabId) {
  let layoutChanged = false;
  const newOuterLayout = outerLayout.map((item) => {
    if (!item.tab_id) {
      layoutChanged = true;
      return { ...item, tab_id: tabId };
    }
    return item;
  });
  return { newOuterLayout, layoutChanged };
}

export function removeTabIdFromLayout(outerLayout) {
  return outerLayout.map((item) => {
    return {
      ...item,
      tab_id: ""
    };
  });
}

export function assignTabIdToField(layout, tabId, fieldId) {
  return layout.map((item) => {
    if (item.i === fieldId) {
      return {
        ...item,
        tab_id: tabId
      };
    }
    return item;
  });
}

export function groupLayoutByTabs(layout, mapOfField) {
  const result = {};

  // Iterate outer_layout
  layout.outer_layout.forEach((item) => {
    const field = mapOfField[item.i];
    if (!field) return;

    const tabId = item.tab_id || "default";

    if (!result[tabId]) {
      result[tabId] = {
        outer_layout: []
      };
    }

    result[tabId].outer_layout.push(item);

    if (field.type === "recordset-list" && layout[item.i]) {
      result[tabId] = {
        ...result[tabId],
        [item.i]: layout[item.i]
      };
    }
  });

  return result;
}

export function updateGlobalOuterLayoutOnTabChange(currentLayout, updatedLayout, tabId) {
  const updatedMap = new Map(updatedLayout.map((item) => [item.i, item]));
  const newLayout = [];

  currentLayout.forEach((item) => {
    if (updatedMap.has(item.i)) {
      const updatedItem = { ...updatedMap.get(item.i), tab_id: tabId };
      newLayout.push(updatedItem);
      updatedMap.delete(item.i);
    } else {
      newLayout.push(item);
    }
  });

  return newLayout;
}

export function flattenFieldsToMap(fields) {
  const map = {};

  function traverse(fieldList) {
    fieldList.forEach((field) => {
      // Add field itself
      map[field.id] = { ...field };

      // If recordset-list, flatten its components too
      if (field.type === "recordset-list" && Array.isArray(field.components)) {
        traverse(field.components);
      }
    });
  }

  traverse(fields);
  return map;
}
